export enum ProductType {
    serialized = 1,
    notSerialized = 2
}